import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueRouter from 'vue-router'
import router from './router'
import VueSSE from './sse'
import StaticData from './data'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faPlay,
  faCircleChevronDown,
  faCircleChevronUp,
  faCircleInfo,
  faChartSimple,
  faSackDollar,
  faCoins,
  faHeartCirclePlus,
  faHouseCrack,
  faChartLine,
  faSkullCrossbones,
  faCircleXmark,
  faCircleCheck,
  faSquareXmark,
  faCampground,
  faCheck,
  faClock,
  faChevronDown,
  faGear,
  faScrewdriverWrench
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'
import VueAxios from 'vue-axios'

// Font Awesome
library.add(
  faTimes,
  faPlay,
  faCircleChevronDown,
  faCircleChevronUp,
  faChartSimple,
  faCircleInfo,
  faSackDollar,
  faCoins,
  faHeartCirclePlus,
  faHouseCrack,
  faChartLine,
  faSkullCrossbones,
  faCircleXmark,
  faCircleCheck,
  faSquareXmark,
  faCampground,
  faCheck,
  faClock,
  faChevronDown,
  faGear,
  faScrewdriverWrench
)
Vue.component('font-awesome', FontAwesomeIcon)

// CSS Override
const loadRemoteStyles = async (cssfile) => {
  try {
    const res = await fetch(`${process.env.VUE_APP_STATS_URL}/static/css/${cssfile}-css.txt`)
    const cssText = await res.text()

    const style = document.createElement('style')
    style.textContent = cssText
    document.head.appendChild(style)

    convertHexVarsToRgb()
  } catch (err) {
    console.error('Failed to load remote styles:', err)
  }
}

// Load external styles
loadRemoteStyles('override')
loadRemoteStyles('colors')
loadRemoteStyles('typography')
loadRemoteStyles('transitions')

// Convert hex CSS vars to RGB format
function convertHexVarsToRgb() {
  const root = document.documentElement
  const styles = getComputedStyle(root)

  // List of your hex color variables
  const colorVars = [
    '--color_white',
    '--color_black',
    '--color_primary',
    '--color_secondary',
    '--color_yellow',
    '--color_red',
    '--color_blue',
    '--color_green',
    '--color_bluishgrey',
    '--color_dark_bluishgrey',
    '--color_dark_blue',
    '--color_dark_red',
    '--color_dark_green',
    '--color_lightblue',
    '--color_lightyellow',
    '--color_lightred',
    '--color_lightbluishgrey',
    '--color_highlight_yellow',
    '--color_highlight_red',
    '--color_highlight_blue',
    '--color_slot_0',
    '--color_slot_1',
    '--color_slot_2',
    '--color_slot_3',
    '--color_slot_4',
    '--color_slot_5',
    '--color_slot_6',
    '--color_slot_7',
    '--color_slot_8',
    '--color_slot_9',
    '--color_tier_1',
    '--color_tier_2',
    '--color_tier_3',
    '--color_tier_4',
    '--color_tier_5'
  ]

  colorVars.forEach((varName) => {
    const hex = styles.getPropertyValue(varName).trim()
    if (!hex) return

    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    // Create new --varName-rgb variable
    root.style.setProperty(`${varName}-rgb`, `${r}, ${g}, ${b}`)
  })
}

// Axios
Vue.use(VueAxios, axios)

// SSE
Vue.use(VueSSE, {
  baseUrl: process.env.VUE_APP_BROADCAST_SERVER_URL,
  vuexPrefix: 'PGL_'
})

// Static Data
Vue.use(StaticData)

Vue.use(VueRouter)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
